'use client';

import { useAuthMutations  } from '@/modules/authentication/contracts';
import type { ChangePasswordDto } from '@/modules/authentication/contracts';

import { Result } from '@packages/domain-driven';

export const useChangePassword = () => {
	const { changePasswordMutation } = useAuthMutations();

	const execute = async (dto: ChangePasswordDto) => {
		try {
			await changePasswordMutation.mutateAsync(dto);

			return Result.ok();
		}
		catch {
			return Result.fail('Error changing password');
		}
	};

	return {
		execute,
		...changePasswordMutation,
	};
};
